const preloadImgOptions = {
    root: null,
    rootMargin: "0px",
    threshold: 0.5, // half of element height
};

const observer = new IntersectionObserver(
    (entries, ob) => {
        entries.forEach((entry) => {
            if (!entry.isIntersecting) return;
            ob.unobserve(entry.target);
            const img = entry.target.querySelector("img");
            if (!img || img.complete) return _loaded(entry.target);
            _showLoading([entry.target]);
            img.addEventListener("load", () => _loaded(entry.target), {
                once: true,
            });
        });
    },
    { root: null, rootMargin: "200px 0px", threshold: 0 }
);

const _showLoading = (media) => {
    media.forEach((div) => {
        const loader = div.previousElementSibling;
        if (loader?.classList.contains("loading-overlay"))
            loader.classList.remove("hidden");
    });
};

const _removeLoading = (media) => {
    media.forEach((div) => {
        const loader = div.previousElementSibling;
        if (loader?.classList.contains("loading-overlay"))
            loader.classList.add("hidden");
    });
};

const _loaded = (div) => {
    div.classList.add("loaded");

    const img = div.querySelector("img");
    img.removeEventListener("load", _loaded);
    _removeLoading([div]); // hide loader after delay for relevant items
};

const _initPreloadImg = () => {
    document
        .querySelectorAll(".media--blur-image:not(.loaded)")
        .forEach((el) => observer.observe(el));
};

// init function when navigation between pages
document.addEventListener("DOMContentLoaded", () => {
    _initPreloadImg();
});
_initPreloadImg();
